<template>
  <div class="wrapper-other-payment-form">
    <button
      :disabled="disabled"
      type="button"
      class="btn btn-web font-weight-bold"
      @click="handleClick"
    >
      <span
        v-html="
          $t('apps.pos.button.enterpaidsuccess', {
            number: currencyFormatter(total, { code: currency }),
          })
        "/>
    </button>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    total: {
      type: Number,
      required: true,
    },
    paymentMethod: {
      type: String,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      isUseKeyboardEnter: false,
    }
  },
  computed: {
    ...mapGetters({
      currency: 'getCurrency',
    }),
  },
  mounted () {
    window.addEventListener('keyup', this.handleKeyup, false)
  },
  destroyed () {
    window.removeEventListener('keyup', this.handleKeyup, false)
  },
  methods: {
    handleClick () {
      this.enter()
    },
    handleKeyup (e) {
      const lastSecIsBarcode = this.$store.state.pos.pos.lastSecIsBarcode
      if (!lastSecIsBarcode) {
        if (e.key === 'Enter') {
          this.enter()
        }
      }
    },
    enter () {
      const isValid = true
      const number = this.total
      const paymentMethod = this.paymentMethod
      const isUseKeyboardNumber = false
      const isUseKeyboardEnter = this.isUseKeyboardEnter

      this.$emit('submit', isValid, number, paymentMethod, isUseKeyboardNumber, isUseKeyboardEnter)
    },
  },
}
</script>
<style scoped>
  .wrapper-other-payment-form {
    width: 100%;
  }

  .wrapper-other-payment-form .btn {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    font-size: 28px;
  }

  body[device="desktop"] .wrapper-other-payment-form .btn {
    height: 100px;
  }
</style>



// WEBPACK FOOTER //
// src/components/apps/pos/sale/main/common/OtherPaymentForm.vue